import { fetchWidgetsAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/FetchWidgetsAction";
import { manageWidgetDragAndDropAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/ManageWidgetDragAndDropAction";
import { savePersonalizeExperienceAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/SavePersonalizeExperienceAction";
import { setFavoriteDepartureFieldsToAtomAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/SetFavoriteDepartureFieldsToAtomAction";
import { setFavoriteTripsForTodayFieldsToAtomAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/SetFavoriteTripsForTodayFieldsToAtomAction";
import { updateFavoriteTripForTodayAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/UpdateFavoriteTripForTodayAction";
import { updateFavouriteDepartureAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/UpdateFavouriteDepartureAction";
import { updatePersonalizeFavoriteDepartureFieldValueAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/UpdatePersonalizeFavoriteDepartureFieldValueAction";
import { updatePersonalizeFavoriteTripFieldValueAction } from "../../../../Actions/LogicActions/MyAccount/PersonalizeExperience/UpdatePersonalizeFavoriteTripFieldValueAction";
import { getSeatingPreferencesAction } from "../../../../Actions/LogicActions/Search/getSeatingPreferencesAction";
import { getTicketOptionsAction } from "../../../../Actions/LogicActions/Search/GetTicketOptionsAction";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { bookingTree, myAccountTree } from "../../../../Orchestrator/ConstantTree";
import { IUserResponse, IRailPreferences } from "../../../../Orchestrator/Types/Index";

class PersonalizeExperienceInitStep extends StepFlow {
  get stepName() { return "PersonalizeExperienceInit_Step"; }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<{ formValues: Partial<IRailPreferences>, userData: IUserResponse }, any>({
        eventName: myAccountTree.personalizeExperience.General.Form.Save,
        handler: async (data) => {
          const { userData, formValues } = data.data!;

          if (!formValues.classType && "classType" in formValues) {
            delete formValues.classType;
            delete formValues.ticketOption;
          }

          let favoriteDepartures = userData?.railPreferences?.favoriteDepartures || []
          if (favoriteDepartures.find((loc) => "origin" in loc && loc.origin === formValues.preferredOrigin) === undefined && formValues.preferredOrigin) {
            favoriteDepartures = [{ origin: formValues.preferredOrigin }, ...favoriteDepartures]
          }

          if (favoriteDepartures.find((loc: { origin?: string; destination?: string }) => "destination" in loc && loc.destination === formValues.preferredDestination) === undefined && formValues.preferredDestination) {
            favoriteDepartures = [{ destination: formValues.preferredDestination }, ...favoriteDepartures]
          }

          const existingFavoriteDeparture = userData?.railPreferences?.favoriteDeparture;
          
          const hasFavoriteDepartureOrigin = existingFavoriteDeparture?.origin && existingFavoriteDeparture.origin !== "";
          const hasFavoriteDepartureDestination = existingFavoriteDeparture?.destination && existingFavoriteDeparture.destination !== "";

          let favoriteDeparture: { origin?: string; destination?: string; outboundDepartureTime?: string; classType?: string; ticketOption?: string } = existingFavoriteDeparture ? { ...existingFavoriteDeparture } : {};
          
          if (!hasFavoriteDepartureOrigin && formValues.preferredOrigin) {
            favoriteDeparture.origin = formValues.preferredOrigin;
          }

          if (!hasFavoriteDepartureDestination && formValues.preferredDestination) {
            favoriteDeparture.destination = formValues.preferredDestination;
          }

          const existingPreferredTrips = userData?.railPreferences?.preferredTrips || [];
          const hasPreferredTripOrigin = existingPreferredTrips.length > 0 && 
            existingPreferredTrips[0] && 
            existingPreferredTrips[0].origin && 
            existingPreferredTrips[0].origin !== "";
          
          const hasPreferredTripDestination = existingPreferredTrips.length > 0 && 
            existingPreferredTrips[0] && 
            existingPreferredTrips[0].destination && 
            existingPreferredTrips[0].destination !== "";

          let preferredTrips: any = existingPreferredTrips.length > 0 ? [...existingPreferredTrips] : [];
          
          if ((!hasPreferredTripOrigin || !hasPreferredTripDestination) && 
              (formValues.preferredOrigin || formValues.preferredDestination)) {
            if (preferredTrips.length === 0) {
              preferredTrips = [{
                origin: formValues.preferredOrigin || "",
                destination: formValues.preferredDestination || ""
              }];
            } else {
              preferredTrips[0] = {
                ...preferredTrips[0],
                origin: hasPreferredTripOrigin ? preferredTrips[0].origin : (formValues.preferredOrigin || preferredTrips[0].origin || ""),
                destination: hasPreferredTripDestination ? preferredTrips[0].destination : (formValues.preferredDestination || preferredTrips[0].destination || "")
              };
            }
          }

          const shouldPassFavoriteDeparture = existingFavoriteDeparture || 
            (!hasFavoriteDepartureOrigin && formValues.preferredOrigin) || 
            (!hasFavoriteDepartureDestination && formValues.preferredDestination);

          savePersonalizeExperienceAction.setParams({
            userData: userData,
            railPreferences: {
              ...formValues,
              favoriteDepartures: favoriteDepartures,
              favoriteDeparture: shouldPassFavoriteDeparture ? favoriteDeparture : undefined,
              preferredTrips: preferredTrips.length > 0 ? preferredTrips : undefined,
              seating: formValues.seating
            }
          })
          savePersonalizeExperienceAction.execute()
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.personalizeExperience.Widgets.DragAndDrop,
        handler: async (data: any) => {
          const { manageWidgets } = data?.data || {};

          manageWidgetDragAndDropAction.setParams({
            manageWidgets: manageWidgets
          })
          manageWidgetDragAndDropAction.execute()
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.personalizeExperience.Widgets.FavoriteTripsForToday.Save,
        handler: async (data: any) => {
          const { userData, favoriteTripsForTodayFields, ticketOptions } = data?.data || {};

          updateFavoriteTripForTodayAction.setParams({
            userData: userData,
            favoriteTripsForTodayFields: favoriteTripsForTodayFields,
            ticketOptions: ticketOptions,
          })
          updateFavoriteTripForTodayAction.execute()
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.personalizeExperience.Widgets.FavoriteDepartures.Save,
        handler: async (data: any) => {
          const { userData, favoriteDepartureFields, ticketOptions } = data?.data || {};

          updateFavouriteDepartureAction.setParams({
            userData: userData,
            favoriteDepartureFields: favoriteDepartureFields,
            ticketOptions: ticketOptions,
          })
          updateFavouriteDepartureAction.execute()
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.personalizeExperience.Widgets.FavoriteTripsForToday.UpdateFieldValue,
        handler: async (data: any) => {
          const { fieldName, favoriteTrips, value, valueLabel, valueCode } = data?.data || {};

          updatePersonalizeFavoriteTripFieldValueAction.setParams({
            fieldName: fieldName,
            favoriteTrips: favoriteTrips,
            value: value,
            valueLabel: valueLabel,
            valueCode: valueCode,
          })
          updatePersonalizeFavoriteTripFieldValueAction.execute();
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.personalizeExperience.Widgets.FavoriteDepartures.UpdateFieldValue,
        handler: async (data: any) => {
          const { fieldName, favoriteDeparture, value, valueLabel, valueCode } = data?.data || {};

          updatePersonalizeFavoriteDepartureFieldValueAction.setParams({
            fieldName: fieldName,
            favoriteDeparture: favoriteDeparture,
            value: value,
            valueLabel: valueLabel,
            valueCode: valueCode,
          })
          updatePersonalizeFavoriteDepartureFieldValueAction.execute();
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.personalizeExperience.Widgets.FavoriteTripsForToday.SetFieldsToAtom,
        handler: async (data: any) => {
          const { userData, listOfStops } = data?.data || {};

          setFavoriteTripsForTodayFieldsToAtomAction.setParams({
            userData: userData,
            listOfStops: listOfStops,
          })
          setFavoriteTripsForTodayFieldsToAtomAction.execute();
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.personalizeExperience.Widgets.FavoriteDepartures.SetFieldsToAtom,
        handler: async (data: any) => {
          const { userData, listOfStops } = data?.data || {};

          setFavoriteDepartureFieldsToAtomAction.setParams({
            userData: userData,
            listOfStops: listOfStops,
          })
          setFavoriteDepartureFieldsToAtomAction.execute();
        }
      })
    )


    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.personalizeExperience.Widgets.FetchWidgets,
        handler: async () => {
          fetchWidgetsAction.execute()
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: bookingTree.ticketOptions.get,
        handler: () => {
          getTicketOptionsAction.execute();
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: bookingTree.seatingPreferences.get,
        handler: () => {
          getSeatingPreferencesAction.execute();
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.exitStep,
        handler: () => {
          this.next();
        }
      })
    )
  }

  async onExecute(): Promise<void> {
    console.log("Personal Experience Page Initialize.....")
  }
}

export const PersonalizeExperienceInitStepDeclaration = new StepDefinition({
  stepName: "PersonalizeExperienceInit_Step",
  stepClass: PersonalizeExperienceInitStep,
})
